export default class SocialChannelVO
{
    id: string;
    nameKey: string;
    title: string;
    url: string;

    constructor(id:string = "", nameKey:string = "", title:string = "", url:string = "")
    {
        this.id = id;
        this.nameKey = nameKey;
        this.title = title;
        this.url = url;
    }

    clone(to?:SocialChannelVO): SocialChannelVO
    {
        to = to ?? new SocialChannelVO();
        to.id = this.id;
        to.nameKey = this.nameKey;
        to.title = this.title;
        to.url = this.url;

        return to;
    }
}


export const allSocialChannelsVOs:SocialChannelVO[] = [
    new SocialChannelVO("url_facebook", "url_facebook", "Facebook"),
    new SocialChannelVO("url_twitter", "url_twitter", "Twitter/X"),
    new SocialChannelVO("url_linkedin", "url_linkedin", "LinkedIn"),
    new SocialChannelVO("url_youtube", "url_youtube", "YouTube"),
    new SocialChannelVO("url_instagram", "url_instagram", "Instagram"),
    new SocialChannelVO("url_tiktok", "url_tiktok", "TikTok")
];